import React, { ReactNode } from 'react';
import { ExceedConstrain } from '@moda/om';
import { ApolloError } from '@apollo/client';
import { SortOption } from '../../../constants';
import { StickUnderNav } from '../../StickUnderNav';
import { PLPBreadcrumbs } from '../../PLPBreadcrumbs';
import { SalePercentageTags } from '../../SalePercentageTags/SalePercentageTags';
import { ProductListingVisualStyleFilters } from '../ProductListingVisualStyleFilters';
import { ProductListPageResultFragment } from '../../../generated/types/ProductListPageResultFragment';
import { GuidePageQuery_displayPage as DisplayPage } from '../../../generated/types/GuidePageQuery';
import { ProductListingMobileSort } from './ProductListingMobileSort';
import { ProductListingMobileFilter } from './ProductListingMobileFilter';
import { ProductListingMobileHeader } from './ProductListingMobileHeader';

import './ProductListingMobile.scss';

type Props = {
  currentSort: SortOption;
  onSortChanged: (sort: string) => void;
  availableSorts: SortOption[];
  headerText?: string;
  error?: ApolloError;
  description?: string;
  showPLPBreadcrumbs?: boolean;
  displayPage?: DisplayPage | null;
  queryResult?: ProductListPageResultFragment | null;
  belowHeader?: ReactNode;
  children?: React.ReactNode;
};

export const ProductListingMobile: React.FC<Props> = ({
  children,
  headerText,
  currentSort,
  queryResult,
  displayPage,
  onSortChanged,
  availableSorts,
  showPLPBreadcrumbs,
  belowHeader
}) => (
  <div className="ProductListingMobile">
    {showPLPBreadcrumbs && <PLPBreadcrumbs />}

    <ProductListingMobileHeader
      headerText={headerText}
      totalItems={queryResult?.totalItems || 0}
      belowHeader={belowHeader}
    />

    <SalePercentageTags saleTags={queryResult?.saleTags || []} />

    <ProductListingVisualStyleFilters
      filters={queryResult?.visualStyleFilters || null}
      categoryTree={queryResult?.categoryTree || null}
    />

    <StickUnderNav className="ProductListingMobile__actions-wrapper">
      <ExceedConstrain className="ProductListingMobile__actions">
        <ProductListingMobileFilter queryResult={queryResult} displayPage={displayPage} />
        <ProductListingMobileSort
          availableSorts={availableSorts}
          currentSort={currentSort}
          onSortChanged={onSortChanged}
        />
      </ExceedConstrain>
    </StickUnderNav>
    {children}
  </div>
);
